import { render } from "./CustomerGroupPricingForZone.html?vue&type=template&id=21715b8d&scoped=true"
import script from "./CustomerGroupPricingForZone.js?vue&type=script&lang=js"
export * from "./CustomerGroupPricingForZone.js?vue&type=script&lang=js"

import "./CustomerGroupPricingForZone.css?vue&type=style&index=0&id=21715b8d&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21715b8d"]])

export default __exports__